<div class="heading">
  Add Business Details
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <formly-form [model]="model" [fields]="fields" [form]="form"></formly-form>
  <button type="submit" pButton class="btn btn-primary mt-6" style="font-weight: 600">
    Next <i class="pi pi-arrow-right arrow-icon" style="margin-left: 8px;"></i>
  </button>
</form>
